import { render, staticRenderFns } from "./MovementTextNoteModal.vue?vue&type=template&id=402343ca&"
import script from "./MovementTextNoteModal.vue?vue&type=script&lang=js&"
export * from "./MovementTextNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports